<template>
    <div
        :class="[
            'web-news-video-list',
            {
                isPC: !isH5
            }
        ]"
    >
        <div v-if="isPreRender" key="hideContent"></div>
        <div v-else-if="loading" class="loading">
            <img src="../images/loading.png" alt="loading..." />
        </div>
        <div
            v-else-if="showContent"
            key="showContent"
            class="content-wrapper"
            :style="{
                '--split-color': splitColor,
                paddingBottom: showBtn ? '0.42rem' : '0'
            }"
        >
            <div class="web-news-video-list-content">
                <a
                    v-for="(item, index) in showCountList"
                    :key="index"
                    class="item"
                    @click="onClickItem(item)"
                    href="javascript:;"
                >
                    <div class="cover-pic">
                        <img :src="item.videoImg" :alt="item.title" />
                        <div class="duration">
                            <!-- 播放时长 -->
                            {{ formatDuration(item.videoDuration) }}
                        </div>
                    </div>
                    <div class="title" :style="{ color: titleColor }">{{ item.title }}</div>
                    <div class="source" :style="{ color: sourceColor }">
                        {{ item.source }} · {{ formatTime(item.timestamp) }}
                    </div>
                </a>
            </div>
            <div class="btn" v-if="showBtn">
                <a
                    :class="[
                        'more-text',
                        {
                            isMoo: isMoo
                        }
                    ]"
                    :style="{
                        '--more-color': moreColor
                    }"
                    href="javascript:;"
                    @click="onClickMore"
                >
                    {{ moreText }}
                    <svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2.25 2L9.75 9.5L2.25 17"
                            stroke-width="2"
                            stroke-linecap="square"
                            stroke-linejoin="round"
                        />
                    </svg>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
const {
    common: {
        request: { bindCommonApi },
        behavior: { runBehaviour }
    }
} = require('@futuweb/fego-render');

const commonApiRequest = bindCommonApi('web-news-video-list');
import { isH5, getIsPreRender, isMoo, getEntity } from '../utils';
import { LANG_NUM_MAP } from '../constants/i18n';
import { NN_NEWS_VIDEO_URL, MM_NEWS_VIDEO_URL } from '../constants/index';
import { ToolDateFormatter, TEMPLATE_YMD, TEMPLATE_HMS } from '@futuweb/tool-date-formatter';

const toolDateFormatter = new ToolDateFormatter({
    entity: getEntity()
});

export default {
    name: 'web-news-video-list',
    props: {
        language: {
            type: String,
            default: 'en-us'
        },
        titleColor: {
            type: String,
            default: '#0F1112'
        },
        sourceColor: {
            type: String,
            default: '#606266'
        },
        splitColor: {
            type: String,
            default: '#EEEFEF'
        },
        // 展示条数
        showCount: {
            type: Number,
            default: 3
        },
        // 查看更多
        moreText: {
            type: String,
            default: 'More'
        },
        moreColor: {
            type: String,
            default: '#327FFF'
        },
        needLogin: {
            type: Boolean,
            default: true
        },
        showBtn: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            loading: false,
            isH5: isH5(),
            isPreRender: getIsPreRender(),
            list: [],
            isMoo: isMoo()
        };
    },
    computed: {
        showContent() {
            return !this.loading && this.list && this.list.length;
        },
        showCountList() {
            return this.list.slice(0, this.showCount);
        }
    },
    async mounted() {
        if (this.isPreRender) {
            return;
        }
        this.loading = true;

        try {
            const data = await commonApiRequest.get(
                'list',
                {
                    lang: LANG_NUM_MAP[this.language],
                    size: this.showCount
                },
                {
                    group: null
                }
            );
            this.list = data && data.list;
        } catch (error) {
            this.list = []; // 不展示
        }

        this.loading = false;
    },
    methods: {
        formatTime(time) {
            const isToday =
                toolDateFormatter.dateFormatByTemplate({
                    dateTemplateArr: [TEMPLATE_YMD.YEAR_MONTH_DAY],
                    timestamps: time * 1e3,
                    lang: LANG_NUM_MAP[this.language]
                }) ===
                toolDateFormatter.dateFormatByTemplate({
                    dateTemplateArr: [TEMPLATE_YMD.YEAR_MONTH_DAY],
                    timestamps: Date.now(),
                    lang: LANG_NUM_MAP[this.language]
                });

            if (isToday) {
                return toolDateFormatter.dateFormatByTemplate({
                    dateTemplateArr: [TEMPLATE_HMS.HOUR_MINUTE],
                    timestamps: time * 1e3,
                    lang: LANG_NUM_MAP[this.language]
                });
            }

            return toolDateFormatter.dateFormatByTemplate({
                dateTemplateArr: [TEMPLATE_YMD.MONTH_DAY, TEMPLATE_HMS.HOUR_MINUTE],
                timestamps: time * 1e3,
                lang: LANG_NUM_MAP[this.language]
            });
        },
        formatDuration(duration) {
            const minutes = Math.floor(duration / 60);
            const seconds = duration % 60;

            // 补零函数，确保分钟和秒数都是两位数字
            function padZero(num) {
                if (num < 10) {
                    return '0' + num;
                }
                return num.toString();
            }

            return `${minutes}:${padZero(seconds)}`;
        },
        onClickItem(item) {
            const url = item.targetUrl;
            if (this.needLogin) {
                return runBehaviour(this, {
                    type: 'login',
                    value: url,
                    lang: this.language,
                    withQuery: true
                });
            }
            return (location.href = url);
        },
        onClickMore() {
            const url = this.isMoo
                ? `${MM_NEWS_VIDEO_URL}?lang=${this.language}`
                : `${NN_NEWS_VIDEO_URL}?lang=${this.language}`;
            if (this.needLogin) {
                return runBehaviour(this, {
                    type: 'login',
                    value: url,
                    lang: this.language,
                    withQuery: true
                });
            }
            return (location.href = url);
        }
    }
};
</script>
<style lang="less" scoped>
.web-news-video-list {
    height: auto !important;
    font-family: brRegular, 'FZLanTingHei-R-GBK', 'BR Hendrix', 'PingFang SC', 'PingFang HK', -apple-system,
        'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'ヒラギノ角ゴ Pro W3',
        'Hiragino Kaku Gothic Pro', Meiryo, 'ＭＳ Ｐゴシック', 'MS PGothic';
    &.ja {
        font-family: brRegular, 'SourceHanSansJP-Regular', 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', Meiryo,
            'ＭＳ Ｐゴシック', 'MS PGothic', 'BR Hendrix', 'PingFang SC', 'PingFang HK', -apple-system,
            'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    }
    .web-news-video-list-content {
        position: relative;
        .item {
            position: relative;
            padding: 0.32rem 0.36rem 0.32rem;
            display: block;
            &:not(:last-child) {
                &::after {
                    content: '';
                    position: absolute;
                    left: 0.32rem;
                    right: 0.32rem;
                    bottom: 0;
                    height: 0.02rem;
                    background-color: var(--split-color);
                }
            }
            .cover-pic {
                width: 6.78rem;
                height: 3.8rem;
                margin-left: auto;
                margin-right: auto;
                margin-bottom: 0.16rem;
                position: relative;
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 0.16rem;
                    object-fit: cover;
                }
                .duration {
                    position: absolute;
                    left: 0.16rem;
                    bottom: 0.16rem;
                    padding: 0.08rem 0.12rem;
                    border-radius: 0.12rem;
                    font-size: 0.28rem;
                    line-height: 0.28rem;
                    color: #fff;
                    border-radius: 0.24rem;
                    background-color: rgba(0, 0, 0, 0.3);
                }
            }
            .source {
                font-size: 0.24rem;
                line-height: 1.35;
            }
            .title {
                font-size: 0.32rem;
                line-height: 1.35;
                margin-bottom: 0.12rem;
                // 限制两行
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
            }
        }
    }
    .content-wrapper {
        position: relative;
        // padding-bottom: 0.42rem;
        .btn {
            display: flex;
            justify-content: center;
            .more-text {
                font-size: 0.3rem;
                line-height: 0.3rem;
                color: var(--more-color);
                display: flex;
                align-items: center;
                svg {
                    margin-left: 0.12rem;
                    width: 0.15rem;
                    height: 0.26rem;
                    path {
                        stroke: var(--more-color);
                    }
                }
            }
        }
    }
    .loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 2rem;
        @keyframes rotate {
            0% {
                transform: rotate(0);
            }
            100% {
                transform: rotate(360deg);
            }
        }
        img {
            width: 0.56rem;
            height: 0.56rem;
            background: url('../images/loading.png') center / contain no-repeat;
            animation: rotate 2s linear infinite;
        }
    }
}
.web-news-video-list.isPC {
    .web-news-video-list-content {
        .item {
            margin: auto;
            width: fit-content;
            cursor: pointer;
            &:not(:last-child) {
                &::after {
                    content: '';
                    position: absolute;
                    left: 0.24rem;
                    right: 0.24rem;
                    bottom: 0;
                    height: 0.02rem;
                    background-color: var(--split-color);
                }
            }
            .cover-pic {
                width: 5.085rem;
                height: 2.85rem;
                margin-bottom: 0.12rem;
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 0.12rem;
                    object-fit: cover;
                }
                .duration {
                    left: 0.12rem;
                    bottom: 0.12rem;
                    padding: 0.06rem 0.09rem;
                    border-radius: 0.09rem;
                    font-size: 0.21rem;
                    line-height: 0.21rem;
                    border-radius: 0.18rem;
                }
            }
            .title {
                width: 5.085rem;
                font-size: 0.24rem;
                margin-bottom: 0.09rem;
            }
            .source {
                font-size: 0.18rem;
            }
        }
    }
    .content-wrapper {
        margin: auto;
        .btn {
            .more-text {
                font-size: 0.22rem;
            }
        }
    }
    .loading {
        height: 3rem;
    }
}
</style>
